import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import VenueForm from './VenueForm';

function EditVenue() {
  const { id } = useParams();
  const [form, setForm] = useState({
    venue_name: '',
    description: '',
    live_music_ind: false,
    dancefloor_ind: true,
    live_ind: true,
    music_ids: [],
    location_id: ''
  });
  const [musicOptions, setMusicOptions] = useState([]);
  const [locationOptions, setLocationOptions] = useState([]);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const token = localStorage.getItem('authToken');

  useEffect(() => {
    const fetchOptions = async () => {
      const musicRes = await fetch('/api/music', { headers: { 'Authorization': `Bearer ${token}` } });
      if (musicRes.ok) setMusicOptions(await musicRes.json());

      const locRes = await fetch('/api/locations', { headers: { 'Authorization': `Bearer ${token}` } });
      if (locRes.ok) setLocationOptions(await locRes.json());
    };

    const fetchVenue = async () => {
      const res = await fetch(`/api/venues/${id}`, { headers: { 'Authorization': `Bearer ${token}` } });
      if (res.ok) {
        const data = await res.json();
        setForm({
          venue_name: data.venue_name,
          description: data.description,
          live_music_ind: data.live_music_ind,
          dancefloor_ind: data.dancefloor_ind,
          live_ind: data.live_ind,
          music_ids: data.music_ids || [],
          location_id: data.location_id || ''
        });
      }
    };

    fetchOptions();
    fetchVenue();
  }, [id, token]);

  const handleChange = (e) => setForm({ ...form, [e.target.name]: e.target.value });

  const handleSubmit = async () => {
    setIsSubmitting(true);
    const res = await fetch(`/api/venues/${id}`, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`
      },
      body: JSON.stringify(form)
    });

    if (res.ok) {
      alert('Venue updated!');
    } else {
      const data = await res.json();
      alert(data.message || 'Error updating venue');
    }
    setIsSubmitting(false);
  };

  return (
    <VenueForm
      form={form}
      onChange={handleChange}
      onSubmit={handleSubmit}
      isSubmitting={isSubmitting}
      musicOptions={musicOptions}
      locationOptions={locationOptions}
    />
  );
}

export default EditVenue;
